export const PROVIDERS = '/providers';
export const ALL_PROVIDERS = '/providers/all';
export const FETCH_PROVIDER_BY_USERID = (id: number) => `/providers/user/${id}`;
export const FETCH_PROVIDER_BY_ID = (id: number) => `/providers/${id}`;
export const DELETE_PROVIDER = (id: number) => `/providers/${id}`;
export const PROVIDERS_WITH_PA = `providers/performance-attribution`;
export const FETCH_PROVIDER_DATA_QUALITY = (id: number) => `providers/data-quality-details/${id}`;
export const FETCH_MASTER_PROVIDER_LIST = (id: Number) => `/masterProviders/all`;
